export const queryKeys = {
	me: () => ["me"] as const,
	notificationPreferences: () =>
		["users", "me", "notificationPreferences"] as const,
	properties: () => ["properties"] as const,
	property: (id: string) => ["properties", id] as const,
	propertyMemberships: (id: string) =>
		["properties", id, "memberships"] as const,
	propertyInvitations: (id: string) =>
		["properties", id, "invitations"] as const,
	propertyJournal: (id: string, projectId?: string) =>
		projectId
			? (["properties", id, "journal", { projectId }] as const)
			: (["properties", id, "journal"] as const),
	propertyTickets: (
		id: string,
		filters?: {
			status?: string
			projectId?: string
			assigneeId?: string
			topicId?: string
			kind?: string
		},
	) => {
		const clean = Object.fromEntries(
			Object.entries(filters ?? {}).filter(([, value]) => value !== undefined),
		)
		return Object.keys(clean).length > 0
			? (["properties", id, "tickets", clean] as const)
			: (["properties", id, "tickets"] as const)
	},
	ticket: (propertyId: string, ticketId: string) =>
		["properties", propertyId, "tickets", ticketId] as const,
	ticketComments: (propertyId: string, ticketId: string) =>
		["properties", propertyId, "tickets", ticketId, "comments"] as const,
	myTicketsRoot: () => ["users", "me", "tickets"] as const,
	myTickets: (filters?: {
		status?: string
		propertyId?: string
		projectId?: string
		kind?: string
	}) => {
		const clean = Object.fromEntries(
			Object.entries(filters ?? {}).filter(([, value]) => value !== undefined),
		)
		return Object.keys(clean).length > 0
			? (["users", "me", "tickets", clean] as const)
			: (["users", "me", "tickets"] as const)
	},
	projects: (propertyId: string) =>
		["properties", propertyId, "projects"] as const,
	topics: (propertyId: string) => ["properties", propertyId, "topics"] as const,
	project: (propertyId: string, projectId: string) =>
		["properties", propertyId, "projects", projectId] as const,
	inspirations: (propertyId: string, projectId: string) =>
		["properties", propertyId, "projects", projectId, "inspirations"] as const,
	visualizations: (propertyId: string, projectId: string) =>
		[
			"properties",
			propertyId,
			"projects",
			projectId,
			"visualizations",
		] as const,
	projectDocuments: (propertyId: string, projectId: string) =>
		["properties", propertyId, "projects", projectId, "documents"] as const,
	propertyDocuments: (propertyId: string) =>
		["properties", propertyId, "documents"] as const,
	propertyBudget: (propertyId: string) =>
		["properties", propertyId, "budget-entries"] as const,
	documentGrantCandidates: (propertyId: string, documentId: string) =>
		[
			"properties",
			propertyId,
			"documents",
			documentId,
			"grant-candidates",
		] as const,
	documentAiReview: (propertyId: string, documentId: string) =>
		["properties", propertyId, "documents", documentId, "ai-review"] as const,
	lastAiResponse: (id: string) =>
		["properties", id, "ai-response-last"] as const,
	chatMessages: (propertyId: string, chatId: string) =>
		["properties", propertyId, "chats", chatId, "messages"] as const,
	// Transient "Mareczek is working" flag, per chat thread (ZPL-152) — the
	// private chat, a shared property chat and a project chat each spin alone.
	mareczekThinking: (chatId: string) =>
		["chats", chatId, "mareczek-thinking"] as const,
}
